import { TranslationsFile } from './d';
import { Translations } from './TranslationContext';

export function parseTranslationsFile(file: TranslationsFile): Translations {
  if (!file) {
    return {};
  }

  if (file.prefix) {
    const withPrefix = Object.entries(file.translations)
      // disable linting error complaining about file.prefix being undef (our condition checks this above)
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      .map(([key, value]) => [`${file.prefix}${key}`, value]);
    return Object.fromEntries(withPrefix) as Record<string, string>;
  }

  return file.translations;
}

export default parseTranslationsFile;
